import { extends as _extends } from '../_virtual/_rollupPluginBabelHelpers.mjs';
import { getLruCache } from './lru-cache.mjs';
import { createClassUtils } from './class-utils.mjs';

function createConfigUtils(config) {
  return _extends({
    cache: getLruCache(config.cacheSize)
  }, createClassUtils(config));
}

export { createConfigUtils };
//# sourceMappingURL=config-utils.mjs.map
